<template>
  <div class="setup-account">
    <top></top>
    <div class="topbar">
      <router-link to="/all-users" class="back-btn">Back to users</router-link>
    </div>
    <div class="topbar">
      <div class="avatar">
        <span>
          <strong>{{ getLetters(user_name) }}</strong>
        </span>
      </div>
      &nbsp;
      <strong>{{ user_name }}</strong>
    </div>
    <div class="folders browse-user">
      <div class="row">
        <div class="col-md-2">
          <ul class="defaultfolder">
            <li v-for="(folder, index) in default_folders" :key="index" @click="browse_default(folder, folder.name)"><span
                class="fa fa-folder"></span> &nbsp;{{ folder.name }}</li>
            <li @click="myfav"><span class="fa fa-folder"></span> &nbsp;Favourites</li>
            <li @click="sharedfiles"><span class="fa fa-folder"></span> &nbsp;Shared Files</li>
            <li @click="sharedwithme"><span class="fa fa-folder"></span> &nbsp;Shared With Me</li>
          </ul>
          <ul class="public">
            <li @click="browse_public"><span class="fa fa-folder"></span> &nbsp;Public</li>
          </ul>
          <ul class="group">
            <li @click="browse_group"><span class="fa fa-folder"></span> &nbsp;Group Folder</li>
          </ul>
          <ul class="messenger">
            <li><span class="fa fa-folder"></span> &nbsp;Messenger Files</li>
          </ul>
          <ul class="trash">
            <li @click="browse_trash"><span class="fa fa-trash"></span> &nbsp;Trash</li>
          </ul>
        </div>
        <div class="col-md-10">
          <div class="toggle">
            <span class="view-type" @click="view_type">
              <img src="@/assets/icons8-checkmark-12.png" v-if="view == 'grid'" />&nbsp;<i class="fa fa-th"></i>&nbsp;
              Grid View
            </span>
            &nbsp;&nbsp;&nbsp;
            <span class="view-type" @click="view_type">
              <img src="@/assets/icons8-checkmark-12.png" v-if="view == 'list'" />&nbsp;<i class="fa fa-list"></i>&nbsp;
              List View
            </span>
          </div>
          <div class="breadcrumb-nav">
            <breadcrumb :path=path @browse_dir="browse_dir" v-if="path && path.length > 0"></breadcrumb>
            <span v-if="!path || path.length === 0" style="font-weight: bold;font-size: 22px;">Fexspace</span>
          </div>
          <div class="">
            <template v-if="view === 'list'">
              <div class="list-view">
                <table v-if="directory_children.length">
                  <tr>
                    <td width="50%" align="left">
                      <strong>Name</strong>
                    </td>
                    <td width="30%">
                      <strong>Date Modified</strong>
                    </td>
                    <td width="20%">
                      <strong>Size</strong>
                    </td>
                    <td>

                    </td>
                  </tr>
                  <tr v-for="(file, index) in directory_children" :key="index" @click="browse(index)">
                    <td class="browse_parent">
                      <span @click="browse(index, file)" class="browse_folder" :title=file.dir>
                        <ext :data="{ dir: file, index: index }"></ext>{{ str_text(file.dir) }}
                        <span class="favourite" v-if="file.is_favourite">
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                        </span>
                      </span>
                    </td>
                    <td>
                      {{ format_date(file.createdAt) }}
                    </td>
                    <td>
                      {{ $sizeFormat(file.size) }}
                    </td>
                    <td class="action-options">
                      <template v-if="file.is_group">
                        <div class="showdropdown" ref="div" v-if="file.can_move" @click="showdropdown(index, $event)">
                          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                            <path ref="path"
                              d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                          </svg>
                        </div>
                      </template>
                      <template v-if="!file.is_group">
                        <div class="showdropdown" ref="div" v-if="file.can_move" @click="showdropdown(index, $event)">
                          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                            <path ref="path"
                              d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                          </svg>
                        </div>
                      </template>
                      <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                        <userfiledropdown :data="{ data: file, index: index }"></userfiledropdown>
                      </div>
                    </td>
                  </tr>
                </table>
                <table v-if="!directory_children.length" class="no-files">
                  <tr>
                    <td>

                    </td>
                    <td width="60%">
                      Name
                    </td>
                    <td>
                      Modified
                    </td>
                    <td>
                      Size
                    </td>
                    <td></td>
                  </tr>
                  <tr class="no-hover">
                    <td align="center" colspan="5">
                      <svg id="72abf1fc-af5c-4a12-adab-83afeedac95e" data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="228"
                        height="296.38" viewBox="0 0 728 796.38">
                        <defs>
                          <linearGradient id="44dab5fe-2df9-47ba-adb2-140775afca0e" x1="506" y1="757.81" x2="506"
                            y2="51.81" gradientUnits="userSpaceOnUse">
                            <stop offset="0" stop-color="#b3b3b3" stop-opacity="0.25" />
                            <stop offset="0.54" stop-color="#b3b3b3" stop-opacity="0.1" />
                            <stop offset="1" stop-color="#b3b3b3" stop-opacity="0.05" />
                          </linearGradient>
                          <linearGradient id="b071ddd1-33a6-4512-b8b6-1cee124e019a" x1="49.46" y1="96.5" x2="49.46"
                            y2="3.5" xlink:href="#44dab5fe-2df9-47ba-adb2-140775afca0e" />
                          <linearGradient id="d200849e-56d5-45c5-85eb-e9070e3330a6" x1="627.87" y1="796.38" x2="627.87"
                            y2="596.12" gradientUnits="userSpaceOnUse">
                            <stop offset="0" stop-color="gray" stop-opacity="0.25" />
                            <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
                            <stop offset="1" stop-color="gray" stop-opacity="0.1" />
                          </linearGradient>
                          <linearGradient id="39846f9a-c4dd-4a41-91c8-743bb7d77e65" x1="627.87" y1="746.82" x2="627.87"
                            y2="645.68" xlink:href="#d200849e-56d5-45c5-85eb-e9070e3330a6" />
                          <linearGradient id="af8f0828-33b7-4bd6-b50f-ae3d37501acf" x1="611" y1="802.81" x2="611"
                            y2="96.81" xlink:href="#44dab5fe-2df9-47ba-adb2-140775afca0e" />
                          <linearGradient id="152252ce-949a-4e00-886c-6a46b2444b40" x1="154.46" y1="141.5" x2="154.46"
                            y2="48.5" xlink:href="#44dab5fe-2df9-47ba-adb2-140775afca0e" />
                        </defs>
                        <path
                          d="M650,694.81c0-51.76,51.11-99.48,102.87-99.48,7.93,0,15.62-2,23-.16.1-2.26.16-15.54.16-17.82V51.81H328l-92,94.5v611.5H659C649.9,743.37,650,713.15,650,694.81Z"
                          transform="translate(-236 -51.81)" fill="url(#44dab5fe-2df9-47ba-adb2-140775afca0e)" />
                        <path
                          d="M642,704.81a117,117,0,0,1,117-117c3.53,0,7,.17,10.48.47V317h-525V745.81H649.39A116.74,116.74,0,0,1,642,704.81Z"
                          transform="translate(-236 -51.81)" fill="#fcfcfc" />
                        <polygon points="533.09 269.19 6.91 269.19 6.91 94.5 92 5.5 533.09 5.5 533.09 269.19"
                          fill="#fcfcfc" />
                        <rect x="357.59" y="58.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="357.59" y="98.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="357.59" y="138.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="357.59" y="178.59" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                        <rect x="357.59" y="218.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="357.59" y="258.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="84.72" y="343.59" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                        <rect x="84.72" y="387.13" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="84.72" y="365.36" width="372.56" height="10.89" fill="#69f0ae" opacity="0.5" />
                        <rect x="84.72" y="448.82" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                        <rect x="84.72" y="492.37" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="84.72" y="470.59" width="372.56" height="10.89" fill="#e0e0e0" />
                        <rect x="84.72" y="554.06" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                        <rect x="84.72" y="597.6" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="84.72" y="575.83" width="305.41" height="10.89" fill="#e0e0e0" />
                        <polygon points="310 281 50 281 50 54 59 43 79.75 43 310 43 310 281" fill="#6c63ff" />
                        <polygon points="4.91 96.5 94 96.5 94 3.5 4.91 96.5"
                          fill="url(#b071ddd1-33a6-4512-b8b6-1cee124e019a)" />
                        <polygon points="6.91 94.5 92 94.5 92 5.5 6.91 94.5" fill="#f5f5f5" />
                        <g opacity="0.5">
                          <circle cx="627.87" cy="696.25" r="100.13" fill="url(#d200849e-56d5-45c5-85eb-e9070e3330a6)" />
                        </g>
                        <circle cx="627.87" cy="696.25" r="93.72" fill="#3ad29f" />
                        <g opacity="0.5">
                          <polygon
                            points="678.44 684.95 639.16 684.95 639.16 645.68 616.58 645.68 616.58 684.95 577.3 684.95 577.3 707.54 616.58 707.54 616.58 746.82 639.16 746.82 639.16 707.54 678.44 707.54 678.44 684.95"
                            fill="url(#39846f9a-c4dd-4a41-91c8-743bb7d77e65)" />
                        </g>
                        <rect x="618.27" y="653.26" width="19.2" height="85.97" fill="#fff" />
                        <rect x="854.27" y="705.07" width="19.2" height="85.97"
                          transform="translate(1375.93 -167.62) rotate(90)" fill="#fff" />
                        <path
                          d="M755,739.81c0-51.76,51.11-99.48,102.87-99.48,7.93,0,15.62-2,23-.16.1-2.26.16-15.54.16-17.82V96.81H433l-92,94.5v611.5H764C754.9,788.37,755,758.15,755,739.81Z"
                          transform="translate(-236 -51.81)" fill="url(#af8f0828-33b7-4bd6-b50f-ae3d37501acf)" />
                        <path
                          d="M747,749.81a117,117,0,0,1,117-117c3.53,0,7,.17,10.48.47V362h-525V790.81H754.39A116.74,116.74,0,0,1,747,749.81Z"
                          transform="translate(-236 -51.81)" fill="#fff" />
                        <polygon points="638.09 314.19 111.91 314.19 111.91 139.5 197 50.5 638.09 50.5 638.09 314.19"
                          fill="#fff" />
                        <rect x="462.59" y="103.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="462.59" y="143.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="462.59" y="183.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="462.59" y="223.59" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                        <rect x="462.59" y="263.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="462.59" y="303.59" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="189.72" y="388.59" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                        <rect x="189.72" y="432.13" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="189.72" y="410.36" width="372.56" height="10.89" fill="#69f0ae" opacity="0.5" />
                        <rect x="189.72" y="493.82" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                        <rect x="189.72" y="537.37" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="189.72" y="515.59" width="372.56" height="10.89" fill="#e0e0e0" />
                        <rect x="189.72" y="599.06" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                        <rect x="189.72" y="642.6" width="142.73" height="10.89" fill="#e0e0e0" />
                        <rect x="189.72" y="620.83" width="305.41" height="10.89" fill="#e0e0e0" />
                        <polygon points="415 326 155 326 155 99 164 88 184.75 88 415 88 415 326" fill="#6c63ff" />
                        <polygon points="109.91 141.5 199 141.5 199 48.5 109.91 141.5"
                          fill="url(#152252ce-949a-4e00-886c-6a46b2444b40)" />
                        <polygon points="111.91 139.5 197 139.5 197 50.5 111.91 139.5" fill="#fcfcfc" />
                      </svg>
                      <br />
                      <span style="font-size: 20px;"><strong>No files found here</strong></span>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
            <template v-if="view === 'grid'">
              <div class="grid-files" v-if="directory_children.length">
                <div v-for="(file, index) in directory_children" :key="index">
                  <template v-if="file.is_dir">
                    <div class="header">
                      <div>
                        <svg class="unchecked" style="width:18px;height:18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#f1f1f1"
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width:18px;height:18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </div>
                      <div>
                        <div class="showdropdown" ref="div">
                          <svg style="width:24px;height:24px" viewBox="0 0 24 24" @click="showdropdown(index, $event)"
                            ref="svg">
                            <path ref="path"
                              d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                          </svg>
                        </div>
                        <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                          <userfiledropdown :data="{ data: file, index: index }" :dir=directory_children>
                          </userfiledropdown>
                        </div>
                      </div>
                    </div>
                    <div class="file-ext">
                      <template>
                        <ext :data="{ dir: file, index: index }"></ext>
                      </template>
                    </div>
                    <div class="file-name">
                      <span @click="browse(index, file)" class="can_browse" :title=file.dir>
                        {{ str_text(file.dir) }}
                        <span class="favourite" v-if="file.is_favourite">
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                        </span>
                      </span>
                      <span class="size">
                        {{ $sizeFormat(file.size) }}
                      </span>
                    </div>
                  </template>
                  <template v-if="!file.is_dir">
                    <div class="header">
                      <div>
                        <svg class="unchecked" style="width:18px;height:18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#f1f1f1"
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width:18px;height:18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </div>
                      <div>
                        <div class="showdropdown">
                          <svg style="width:24px;height:24px" viewBox="0 0 24 24" @click="showdropdown(index, $event)">
                            <path ref="path"
                              d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                          </svg>
                        </div>
                        <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                          <userfiledropdown :data="{ data: file, index: index }"></userfiledropdown>
                        </div>
                      </div>
                    </div>
                    <div class="file-ext">
                      <ext :data="{ dir: file, index: index }"></ext>
                    </div>
                    <div class="file-name">
                      <span @click="browse(index, file)" class="can_browse" :title=file.dir>
                        {{ str_text(file.dir) }}
                        <span class="favourite" v-if="file.is_favourite">
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                        </span>
                      </span>
                      <span class="size">
                        {{ $sizeFormat(file.size) }}
                      </span>
                    </div>
                  </template>
                </div>
              </div>
              <div class="empty" v-if="!directory_children.length">
                <svg id="72abf1fc-af5c-4a12-adab-83afeedac95e" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" width="228" height="296.38" viewBox="0 0 728 796.38">
                  <defs>
                    <linearGradient id="44dab5fe-2df9-47ba-adb2-140775afca0e" x1="506" y1="757.81" x2="506" y2="51.81"
                      gradientUnits="userSpaceOnUse">
                      <stop offset="0" stop-color="#b3b3b3" stop-opacity="0.25" />
                      <stop offset="0.54" stop-color="#b3b3b3" stop-opacity="0.1" />
                      <stop offset="1" stop-color="#b3b3b3" stop-opacity="0.05" />
                    </linearGradient>
                    <linearGradient id="b071ddd1-33a6-4512-b8b6-1cee124e019a" x1="49.46" y1="96.5" x2="49.46" y2="3.5"
                      xlink:href="#44dab5fe-2df9-47ba-adb2-140775afca0e" />
                    <linearGradient id="d200849e-56d5-45c5-85eb-e9070e3330a6" x1="627.87" y1="796.38" x2="627.87"
                      y2="596.12" gradientUnits="userSpaceOnUse">
                      <stop offset="0" stop-color="gray" stop-opacity="0.25" />
                      <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
                      <stop offset="1" stop-color="gray" stop-opacity="0.1" />
                    </linearGradient>
                    <linearGradient id="39846f9a-c4dd-4a41-91c8-743bb7d77e65" x1="627.87" y1="746.82" x2="627.87"
                      y2="645.68" xlink:href="#d200849e-56d5-45c5-85eb-e9070e3330a6" />
                    <linearGradient id="af8f0828-33b7-4bd6-b50f-ae3d37501acf" x1="611" y1="802.81" x2="611" y2="96.81"
                      xlink:href="#44dab5fe-2df9-47ba-adb2-140775afca0e" />
                    <linearGradient id="152252ce-949a-4e00-886c-6a46b2444b40" x1="154.46" y1="141.5" x2="154.46" y2="48.5"
                      xlink:href="#44dab5fe-2df9-47ba-adb2-140775afca0e" />
                  </defs>
                  <path
                    d="M650,694.81c0-51.76,51.11-99.48,102.87-99.48,7.93,0,15.62-2,23-.16.1-2.26.16-15.54.16-17.82V51.81H328l-92,94.5v611.5H659C649.9,743.37,650,713.15,650,694.81Z"
                    transform="translate(-236 -51.81)" fill="url(#44dab5fe-2df9-47ba-adb2-140775afca0e)" />
                  <path
                    d="M642,704.81a117,117,0,0,1,117-117c3.53,0,7,.17,10.48.47V317h-525V745.81H649.39A116.74,116.74,0,0,1,642,704.81Z"
                    transform="translate(-236 -51.81)" fill="#fcfcfc" />
                  <polygon points="533.09 269.19 6.91 269.19 6.91 94.5 92 5.5 533.09 5.5 533.09 269.19" fill="#fcfcfc" />
                  <rect x="357.59" y="58.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="357.59" y="98.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="357.59" y="138.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="357.59" y="178.59" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                  <rect x="357.59" y="218.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="357.59" y="258.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="84.72" y="343.59" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                  <rect x="84.72" y="387.13" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="84.72" y="365.36" width="372.56" height="10.89" fill="#69f0ae" opacity="0.5" />
                  <rect x="84.72" y="448.82" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                  <rect x="84.72" y="492.37" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="84.72" y="470.59" width="372.56" height="10.89" fill="#e0e0e0" />
                  <rect x="84.72" y="554.06" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                  <rect x="84.72" y="597.6" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="84.72" y="575.83" width="305.41" height="10.89" fill="#e0e0e0" />
                  <polygon points="310 281 50 281 50 54 59 43 79.75 43 310 43 310 281" fill="#6c63ff" />
                  <polygon points="4.91 96.5 94 96.5 94 3.5 4.91 96.5"
                    fill="url(#b071ddd1-33a6-4512-b8b6-1cee124e019a)" />
                  <polygon points="6.91 94.5 92 94.5 92 5.5 6.91 94.5" fill="#f5f5f5" />
                  <g opacity="0.5">
                    <circle cx="627.87" cy="696.25" r="100.13" fill="url(#d200849e-56d5-45c5-85eb-e9070e3330a6)" />
                  </g>
                  <circle cx="627.87" cy="696.25" r="93.72" fill="#3ad29f" />
                  <g opacity="0.5">
                    <polygon
                      points="678.44 684.95 639.16 684.95 639.16 645.68 616.58 645.68 616.58 684.95 577.3 684.95 577.3 707.54 616.58 707.54 616.58 746.82 639.16 746.82 639.16 707.54 678.44 707.54 678.44 684.95"
                      fill="url(#39846f9a-c4dd-4a41-91c8-743bb7d77e65)" />
                  </g>
                  <rect x="618.27" y="653.26" width="19.2" height="85.97" fill="#fff" />
                  <rect x="854.27" y="705.07" width="19.2" height="85.97"
                    transform="translate(1375.93 -167.62) rotate(90)" fill="#fff" />
                  <path
                    d="M755,739.81c0-51.76,51.11-99.48,102.87-99.48,7.93,0,15.62-2,23-.16.1-2.26.16-15.54.16-17.82V96.81H433l-92,94.5v611.5H764C754.9,788.37,755,758.15,755,739.81Z"
                    transform="translate(-236 -51.81)" fill="url(#af8f0828-33b7-4bd6-b50f-ae3d37501acf)" />
                  <path
                    d="M747,749.81a117,117,0,0,1,117-117c3.53,0,7,.17,10.48.47V362h-525V790.81H754.39A116.74,116.74,0,0,1,747,749.81Z"
                    transform="translate(-236 -51.81)" fill="#fff" />
                  <polygon points="638.09 314.19 111.91 314.19 111.91 139.5 197 50.5 638.09 50.5 638.09 314.19"
                    fill="#fff" />
                  <rect x="462.59" y="103.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="462.59" y="143.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="462.59" y="183.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="462.59" y="223.59" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                  <rect x="462.59" y="263.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="462.59" y="303.59" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="189.72" y="388.59" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                  <rect x="189.72" y="432.13" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="189.72" y="410.36" width="372.56" height="10.89" fill="#69f0ae" opacity="0.5" />
                  <rect x="189.72" y="493.82" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                  <rect x="189.72" y="537.37" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="189.72" y="515.59" width="372.56" height="10.89" fill="#e0e0e0" />
                  <rect x="189.72" y="599.06" width="142.73" height="10.89" fill="#6c63ff" opacity="0.5" />
                  <rect x="189.72" y="642.6" width="142.73" height="10.89" fill="#e0e0e0" />
                  <rect x="189.72" y="620.83" width="305.41" height="10.89" fill="#e0e0e0" />
                  <polygon points="415 326 155 326 155 99 164 88 184.75 88 415 88 415 326" fill="#6c63ff" />
                  <polygon points="109.91 141.5 199 141.5 199 48.5 109.91 141.5"
                    fill="url(#152252ce-949a-4e00-886c-6a46b2444b40)" />
                  <polygon points="111.91 139.5 197 139.5 197 50.5 111.91 139.5" fill="#fcfcfc" />
                </svg>
                <br />
                <span><strong>No files found here</strong></span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <login ref="login"></login>
    <viewpdf ref="viewpdf"></viewpdf>
    <viewfile ref="viewfile"></viewfile>
    <viewtxt ref="viewtxt"></viewtxt>
  </div>
</template>
<style scoped>
table tr td {
  border-bottom: 1px solid #e0dede;
  padding: .5em !important;
  position: relative;
}

.grid-files {
  margin-top: 1.2em;
}

.toggle {
  display: flex;
  flex-direction: row;
}

.view-type {
  display: flex;
  cursor: pointer;
  font-size: 14px;
  justify-content: center;
  align-items: center;
}

.view-type .fa {
  font-size: 16px !important;
}

.folders {
  padding-left: 1em;
  padding-right: 1em;
}

.folders ul {
  text-align: left;
}

.topbar {
  display: flex;
  margin-top: .5em;
  padding-left: 1em;
  padding-bottom: 1em;
}

.back-btn {
  background-color: #044cc9;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, .3) 0 2px 10px 0;
  color: #fff;
  font-size: 15px;
  padding: .8em .6em;
}
</style>
<script>
import top from '@/components/Top'
import moment from 'moment'
import { mapMutations } from 'vuex'
import ext from '@/components/File-Extension'
import login from '@/components/Login'
import breadcrumb from '@/components/User-Breadcrumb'
import userfiledropdown from '@/components/User-File-Drop-Down'
import viewpdf from '@/components/User-View-Pdf'
import viewfile from '@/components/View-User-File'
import viewtxt from '@/components/View-User-Txt'
import { directive as onClickaway } from 'vue-clickaway'
import cookies from '@/services/cookies'
export default {
  components: {
    viewpdf,
    viewfile,
    viewtxt,
    userfiledropdown,
    breadcrumb,
    login,
    ext,
    top
  },
  data() {
    return {
      user_name: '',
      default_folders: [],
      directory_children: [],
      view: 'grid',
      path: '',
      dropdown_index: 0
    }
  },
  methods: {
    ...mapMutations([
      'SET_FILE_ACTION',
      'REMOVE_FILE_ACTION',
      'SET_DIRECTORY_CHILDREN',
      'TOGGLE_FILE_INFO',
      'SORT_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'GET_DIRECTORY_CHILDREN',
      'CLOSE_FILE_INFO',
      'SET_PATH',
      'UPDATE_SLIDEIN',
      'UPDATE_SLIDEOUT',
      'UPDATE_BODY_MENU',
      'UPDATE_MENU',
      'UPDATE_TOTAL_CREATED_IMAGES',
      'UPDATE_TOTAL_CREATED_DOCUMENTS',
      'UPDATE_TOTAL_CREATED_FOLDERS',
      'SET_FIRSTNAME',
      'SET_LASTNAME',
      'SET_EMAIL',
      'SET_PHONE',
      'SET_POSITION',
      'SET_DEPARTMENT',
      'SET_COUNTRY',
      'SET_DATE_CREATED',
      'SET_ACCT_TYPE',
      'SET_ISADMIN',
      'SET_PHOTO',
      'UPDATE_TOTAL_SPACE',
      'UPDATE_DEFAULT_FOLDER',
      'UPDATE_TOTAL_USED_SPACE',
      'SET_ISTRIAL',
      'SET_ISSTAFF',
      'SET_ISSUPERADMIN',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'HIDE_FILE_INFO',
      'SET_FILE_ACTION',
      'SET_USER_PLAN',
      'SET_CURRENT_PLAN',
      'UPDATE_PUBLIC_FOLDER_ID',
      'SET_SELECT_ALL',
      'UPDATE_USER',
      'SET_NAME',
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    logincall() {
      this.$refs.login.load()
    },
    closeDropDown(file) {
      file.show = false
    },
    showmenu(index, file, e) {
      e.preventDefault()
    },
    onClose() {
      this.directory_children[this.dropdown_index].show = false
    },
    async showdropdown(index, e) {
      if (this.directory_children[index].show) {
        this.directory_children[index].show = false
      } else {
        this.directory_children[index].show = true
      }

      let elem = e.target.closest('.showdropdown')
      let { height, left } = elem.getBoundingClientRect()
      let top = e.y
      await this.$nextTick()
      let dropdown = elem.parentElement.querySelector('.file-dropdown')

      if (!dropdown) return
      let winHeight = window.innerHeight
      let winWidth = window.innerWidth

      let dem = dropdown.getBoundingClientRect()

      let dropdown_height = dem.height + height
      let pos = winHeight - top
      let new_height = winHeight - dropdown_height
      let placement
      if (pos < dropdown_height) {
        placement = top - dropdown_height
      } else {
        placement = top + height
      }
      if (winWidth - left < dem.width) {
        dropdown.style.left = left - dem.width + 'px'
      }
      dropdown.style.top = placement + 'px'
      this.dropdown_index = index
      // this.SET_FILE_INDEX(index)

      let dex = 0

      this.directory_children.map(dir => {
        if (dex !== index) {
          this.directory_children.show = false
        }
        dex++
      })
    },
    compareValues(state) {
      return function (a, b) {
        if (!a.hasOwnProperty(state.sort_type) || !b.hasOwnProperty(state.sort_type)) {
          // property doesn't exist on either object
          return 0
        }

        if (state.sort_type !== 'date') {
          const varA = (typeof a[state.sort_type] === 'string') ? a[state.sort_type].toUpperCase() : a[state.sort_type]
          const varB = (typeof b[state.sort_type] === 'string') ? b[state.sort_type].toUpperCase() : b[state.sort_type]
          let comparison = 0
          if (varA > varB) {
            comparison = 1
          } else if (varA < varB) {
            comparison = -1
          }
          return (
            (state.sort_order === 'desc') ? (comparison * -1) : comparison
          )
        } else {
          const varA = new Date(a['date_created'])
          const varB = new Date(b['date_created'])
          return (
            (state.sort_order === 'desc') ? varA - varB : varB - varA
          )
        }
      }
    },
    sort_directory_children() {
      this.directory_children.sort(this.compareValues(this.directory_children))
    },
    viewpdf(id) {
      this.$refs.viewpdf.load(id)
    },
    view_txt(index, id) {
      this.$refs.viewtxt.load(index, id)
    },
    view_file(index, id) {
      this.$refs.viewfile.load(index, id)
    },
    play_audio(index, id) {

    },
    play_video(index, id) {

    },
    myfav() {
      let data = {
        token: cookies.getCookie('token'),
        user: this.$route.params.id
      }

      let that = this

      this.$socket.emit('user-myfav', data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    sharedfiles() {
      let data = {
        token: cookies.getCookie('token'),
        user: this.$route.params.id
      }

      let that = this

      this.$socket.emit('get-user-shared-files', data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    sharedwithme() {
      let data = {
        token: cookies.getCookie('token'),
        user: this.$route.params.id
      }

      let that = this

      this.$socket.emit('get-user-shared-with', data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    browse_default(dir, folder) {
      let data = {
        token: cookies.getCookie('token'),
        user: this.$route.params.id,
        id: dir._id
      }

      let that = this

      let path = ''

      if (folder === 'Documents') {
        path = 'user-get-documents'
      }

      if (folder === 'Photos') {
        path = 'user-get-photos'
      }

      if (folder === 'Videos') {
        path = 'user-get-videos'
      }

      if (folder === 'Music') {
        path = 'user-get-music'
      }

      this.$socket.emit(path, data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
          // that.sort_directory_children()
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    browse(index, dir) {
      if (!dir.is_dir) {
        if (dir.extname === '.pdf') {
          this.viewpdf(dir.id)
        }

        if (dir.extname === '.txt') {
          this.view_txt(dir.id)
        }

        if (dir.extname === '.tar' || dir.extname === '.gz' || dir.extname === '.zip') {

        }

        if (dir.extname === '.doc' || dir.extname === '.docx' || dir.extname === '.xls' || dir.extname === '.xlsx' || dir.extname === '.ppt' || dir.extname === '.pptx') {

        }

        if (dir.type === 'image') {
          this.view_file(index, dir.id)
        }

        if (dir.type === 'audio') {
          this.play_audio(index, dir.id)
        }

        if (dir.type === 'video') {
          this.play_video(index, dir.id)
        }

        return
      }

      if (dir.is_approved === false && dir.is_group === true) {
        this.notify('This folder is not yet approved')
        return
      }

      let data = {
        token: cookies.getCookie('token'),
        current_directory_id: dir.id,
        db: dir.is_group ? 'group' : dir.db,
        user: this.$route.params.id
      }

      let that = this

      this.$socket.emit('browse-user', data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    back() {
      let data = {
        token: cookies.getCookie('token'),
        user: this.$route.params.id
      }

      let that = this

      this.$socket.emit('loadusermainfiles', data, function (data) {
        if (data.data === true) {
          that.path = []
          that.directory_children = data.directory_children
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    view_type() {
      this.view = this.view === 'grid' ? 'list' : 'grid'
    },
    getLetters(names) {
      let name = names.split(' ')
      return name[0][0] + name[name.length - 1][0]
    },
    browse_public() {
      let data = {
        token: cookies.getCookie('token'),
        user: this.$route.params.id
      }

      let that = this

      this.$socket.emit('browse-user-public', data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    browse_group() {
      let data = {
        token: cookies.getCookie('token'),
        db: 'group',
        current_directory_id: undefined,
        user: this.$route.params.id
      }

      let that = this

      this.$socket.emit('browse-user', data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    browse_trash() {
      let data = {
        token: cookies.getCookie('token'),
        user: this.$route.params.id
      }

      let that = this

      this.$socket.emit('get-user-trash-files', data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    browse_dir(dir) {
      let that = this

      let data = {
        db: dir[2],
        token: cookies.getCookie('token'),
        current_directory_id: dir[1],
        user: this.$route.params.id
      }

      this.$socket.emit('browse-user', data, function (data) {
        if (data.data === true) {
          that.directory_children = data.directory_children
          that.path = data.dir_path
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    str_text(str) {
      if (str != null) {
        return str.length > 22 ? str.substr(0, 18) + '...' : str
      }
    },
    format_date(val) {
      return moment(val).format('YYYY-MM-DD HH:MM:SS A')
    },
    user_data() {
      let data = {
        token: cookies.getCookie('token')
      }

      let that = this

      this.$socket.emit('get-data', data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type)
          that.SET_ISADMIN(data.isAdmin)
          that.SET_FIRSTNAME(data.firstname)
          that.SET_LASTNAME(data.lastname)
          that.SET_NAME(data.firstname + ' ' + data.lastname)
          that.SET_EMAIL(data.email)
          that.SET_PHONE(data.phone)
          that.SET_POSITION(data.position)
          that.SET_DEPARTMENT(data.department)
          that.SET_COUNTRY(data.country ? data.country : '')
          that.SET_DATE_CREATED(data.date_created)
          that.SET_PHOTO(data.photo)
          that.UPDATE_TOTAL_SPACE(data.total_space)
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used)
          that.UPDATE_USER(data.id)
          that.SET_CURRENT_PLAN(data.current_plan)
          that.SET_USER_PLAN(data.user_plan)
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          that.SET_ISTRIAL(data.isTrial)
          that.SET_ISSTAFF(data.isStaff)
          that.SET_ISSUPERADMIN(data.isSuperAdmin)

          that.SET_IS_SECURITY_QUESTION(data.is_security_question)

          that.UPDATE_DEFAULT_FOLDER(data.default_folders)

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id)

          localStorage.setItem('email', data.email)
          localStorage.setItem('is_security_question', data.is_security_question)
          sessionStorage.setItem('gi', data.group_folder_id)
          sessionStorage.setItem('pi', data.project_folder_id)

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images)
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents)
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders)
        } else {
          that.$router.push('/login')
        }
      })
    }
  },
  directives: {
    onClickaway: onClickaway
  },
  mounted() {
    this.user_data()

    let data = {
      token: cookies.getCookie('token'),
      user: this.$route.params.id
    }

    let that = this

    this.$socket.emit('get-users-files', data, function (data) {
      if (data.data === true) {
        that.user_name = data.user_name
        that.default_folders = data.default_folders
        that.directory_children = data.directory_children
      }

      if (data.data === false) {
        that.$router.push('/login')
      }
    })
  }
}
</script>
